import { api } from '../api';

/**
 * Ao menos um de `email` ou `cpf` — o back recusa corpo sem nenhum dos dois (`.or`).
 *
 * `phone` **saiu na 0.31**: era exigido aqui, viajava no corpo e a service do back o
 * descartava. Mandá-lo agora é 400, porque a rota ganhou `celebrate`.
 */
interface ValidatePatientDataService {
  id?: string;
  email?: string;
  cpf?: string;
}

export const validatePatientDataService = async (
  patientData: ValidatePatientDataService,
): Promise<boolean> => {
  const { data } = await api.post('/patients/validatePatientData', patientData);

  return data;
};
